import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'
import {Model} from '../../types/Model'
import {SingleSimulation} from '../../types/SingleSimulation'
import {ActiveSimulations} from '../../types/ActiveSimulations'

export const configurationModelsDataSlice = createSlice({
    name: 'configurationModelsDataSlice',
    initialState: {
        fetchModels: [] as Model[],
        fetchActiveSimulations: {} as ActiveSimulations[],
        modelsByPromotions: [] as Model[],
        simulationsList: [] as SingleSimulation[],
    },
    reducers: {
        setFetchModels(state: RootState, action: PayloadAction<Model[]>): void {
            state.fetchModels = action.payload
        },
        setFetchActiveSimulations(
            state: RootState,
            action: PayloadAction<{[key: string]: any}>
        ): void {
            state.fetchActiveSimulations = action.payload
        },
        setModelsByPromotions(
            state: RootState,
            action: PayloadAction<[] | Model>
        ): void {
            state.modelsByPromotions = action.payload
        },
        resetSimulationsList(state: RootState): void {
            state.simulationsList = []
        },
        resetConfigurationModelsData(state: RootState): void {
            state.fetchModels = []
            state.fetchActiveSimulations = {}
            state.modelsByPromotions = []
            state.simulationsList = []
        },
        addSimulation: (state, action) => {
            state.simulationsList.push(action.payload)
        },
    },
})

export const {
    setModelsByPromotions,
    setFetchModels,
    setFetchActiveSimulations,
    resetSimulationsList,
    resetConfigurationModelsData,
    addSimulation,
} = configurationModelsDataSlice.actions
export default configurationModelsDataSlice.reducer
